import { render, staticRenderFns } from "./EdgeInfoModal.vue?vue&type=template&id=aa0539ca"
import script from "./EdgeInfoModal.vue?vue&type=script&lang=js"
export * from "./EdgeInfoModal.vue?vue&type=script&lang=js"
import style0 from "./EdgeInfoModal.vue?vue&type=style&index=0&id=aa0539ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports